export default "__VITE_ASSET__CQE6$8hl__"